module.exports = __webpack_public_path__ + "static/media/PEP-illustration.40ff0027.svg";